import { render, staticRenderFns } from "./SocialsComponent.vue?vue&type=template&id=3f5b4f10"
import script from "./SocialsComponent.vue?vue&type=script&lang=js"
export * from "./SocialsComponent.vue?vue&type=script&lang=js"
import style0 from "./SocialsComponent.vue?vue&type=style&index=0&id=3f5b4f10&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports